import SettlementFeeDetailsCard from 'components/matterDetails/SettlementFeeDetailsCard';
import { Flex } from '@galilee/lilee';
import { StyledSubtitle, UnmarginedPanel } from "./index";

const DisbursementType = {
    SettlementFund: 0,
    BankCheque: 1,
    TrustCheque: 2,
    TelegraphicTransfer: 3,
    DirectCredit: 4,
    RetainedInTrust: 5,
    GalileeCheque: 6,
    RetainedbyFunder: 7,
    OriginatorFee: 8,
    GovernmentFee: 9,        
    BPay: 16
}

const SettlementFeeCard = ({ settlementFees }) => {   
    const settlementFunds = settlementFees.filter(fee => fee.disbursementType === DisbursementType.SettlementFund)
    const galileeFees = settlementFees.filter(fee => fee.disbursementType === DisbursementType.GalileeCheque)
    const originatorFees = settlementFees.filter(fee => fee.disbursementType === DisbursementType.OriginatorFee)
    const bankCheques = settlementFees.filter(fee => fee.disbursementType === DisbursementType.BankCheque)
    const trustCheques = settlementFees.filter(fee => fee.disbursementType === DisbursementType.TrustCheque)
    const telegraphicTransfers = settlementFees.filter(fee => fee.disbursementType === DisbursementType.TelegraphicTransfer)
    const directCreditTransfers = settlementFees.filter(fee => fee.disbursementType === DisbursementType.DirectCredit)
    const bpay = settlementFees.filter(fee => fee.disbursementType === DisbursementType.BPay)
    const heldInTrust = settlementFees.filter(fee => fee.disbursementType === DisbursementType.RetainedInTrust)
    const retainedByFunder = settlementFees.filter(fee => fee.disbursementType === DisbursementType.RetainedbyFunder)
    return (
        <UnmarginedPanel id="settlementFunds">
            <Flex justifyContent="space-between">
                <StyledSubtitle>Settlement Fees and Disbursements</StyledSubtitle>                
            </Flex>  
            {!!settlementFunds?.length && <SettlementFeeDetailsCard settlementFeeDetails = {settlementFunds} feeGroup ='Settlement Funds' />}
            {!!galileeFees?.length && <SettlementFeeDetailsCard settlementFeeDetails = {galileeFees} feeGroup ='Galilee Fees (inc GST)'/>}
            {!!originatorFees?.length && <SettlementFeeDetailsCard settlementFeeDetails = {originatorFees} feeGroup ='Originator Fees'/>}
            {!!bankCheques?.length && <SettlementFeeDetailsCard settlementFeeDetails = {bankCheques} feeGroup ='Bank Cheques'/>}
            {!!trustCheques?.length && <SettlementFeeDetailsCard settlementFeeDetails = {trustCheques} feeGroup ='Trust Cheques'/>}
            {!!telegraphicTransfers?.length && <SettlementFeeDetailsCard settlementFeeDetails = {telegraphicTransfers} feeGroup ='Telegraphic Transfers' showDetails={true}/>}
            {!!directCreditTransfers?.length && <SettlementFeeDetailsCard settlementFeeDetails = {directCreditTransfers} feeGroup ='Direct Credit Transfers' showDetails={true}/>}
            {!!bpay?.length && <SettlementFeeDetailsCard settlementFeeDetails = {bpay} feeGroup ='BPAY' showDetails={true}/>}
            {!!heldInTrust?.length && <SettlementFeeDetailsCard settlementFeeDetails = {heldInTrust} feeGroup ='Held in Trust'/>}
            {!!retainedByFunder?.length && <SettlementFeeDetailsCard settlementFeeDetails = {retainedByFunder} feeGroup ='Retained by Funder'/>}
        </UnmarginedPanel>
    );
};

export default SettlementFeeCard;